import { useFont } from '@octane/spark'
import styled from 'styled-components'

export const AutoBonusTargetContainer = styled.div`
    border-bottom: var(--dashboard-default-border-thin);
    padding: 0 0 20px 5px;
    margin-bottom: 20px;
    width: 100%;
    h3 {
        margin: 20px 0 10px 0;
        ${() => useFont('h24', { weight: '700' })}
        color: ${(props) => props.theme.colors.monochrome.ravenSub};
    }
    .content {
        max-width: 600px;
        ${() => useFont('c16', { weight: '400' })}
        color: ${(props) => props.theme.colors.monochrome.ravenSub};
        header {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            div {
                display: flex;
                flex-direction: column;
                small {
                    color: var(--dashboard-secondary-color);
                }
            }
        }
        .text-success {
            ${() => useFont('c16', { weight: '700' })}
            color: ${(props) => props.theme.colors.alert.success};
        }
        .header-text {
            display: flex;
            align-items: center;
            gap: 5px;
            ${() => useFont('c16', { weight: '700' })}
            svg {
                width: 24px;
                height: 24px;
                color: ${({ theme }) => theme.colors.brand.primary};
                fill: ${({ theme }) => theme.colors.brand.primary};
                display: block;
            }
        }
        .container {
            padding: 10px 0;
            width: 100%;
            .bar {
                background-color: ${(props) =>
                    props.theme.colors.monochrome.smoke};
                width: 100%;
                height: 30px;
                border-radius: 15px;
                position: relative;
                display: flex;
                justify-content: left;
                align-items: center;
                .progress {
                    background-color: ${(props) =>
                        props.theme.colors.alert.success};
                    border-radius: 15px;
                    height: 30px;
                    padding: 0 5px;
                    line-height: 16px;
                    min-width: 30px;
                }
            }
        }
        .footer-info {
            ${() => useFont('c14', { weight: '400' })}
            white-space: nowrap;
        }
        .footer-text {
            display: flex;
            align-items: center;
            gap: 5px;
            ${() => useFont('c16', { weight: '700' })}
            svg {
                width: 30px;
                height: 30px;
                display: block;
            }
        }
    }
    animation: fadeIn 0.8s ease-in-out;
    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translate(0, -15px);
        }
        to {
            opacity: 1;
            transform: translate(0, 0);
        }
    }
`
